// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iv_a bhe_sq","PhotoTitleEditForm__cancelBtn":"iv_b bhe_su bhe_st"};